var _defs, _line, _line2, _line3, _line4, _path, _path2, _line5, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSitesGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:none;stroke:#7F7F7F;stroke-width:3px;}.cls-1{stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-miterlimit:10;}\n        "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.5,
    y1: 34.5,
    x2: 12.5,
    y2: 34.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.5,
    y1: 34.5,
    x2: 40.5,
    y2: 34.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.5,
    y1: 27.5,
    x2: 40.5,
    y2: 27.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.5,
    y1: 9.5,
    x2: 32.5,
    y2: 9.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M42,19a3.00339,3.00339,0,0,1,3,3V42a3.00339,3.00339,0,0,1-3,3H34a3.00339,3.00339,0,0,1-3-3V22a3.00339,3.00339,0,0,1,3-3h8m0-3H34a6.01764,6.01764,0,0,0-6,6V42a6.01764,6.01764,0,0,0,6,6h8a6.01764,6.01764,0,0,0,6-6V22a6.01764,6.01764,0,0,0-6-6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M14,29a3.00339,3.00339,0,0,1,3,3V42a3.00339,3.00339,0,0,1-3,3H6a3.00339,3.00339,0,0,1-3-3V32a3.00339,3.00339,0,0,1,3-3h8m0-3H6a6.01764,6.01764,0,0,0-6,6V42a6.01764,6.01764,0,0,0,6,6h8a6.01764,6.01764,0,0,0,6-6V32a6.01764,6.01764,0,0,0-6-6Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36.47199,
    y1: 46.5,
    x2: 10.94723,
    y2: 46.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.5,26V7.5a6.01764,6.01764,0,0,1,6-6h18a6.01764,6.01764,0,0,1,6,6v9.90607"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSitesGrey);
export default __webpack_public_path__ + "static/media/icon-sites-grey.eb13665315e9c752c27c70ef1dacc6f7.svg";
export { ForwardRef as ReactComponent };